module.exports = __webpack_public_path__ + "static/media/isdoctorplan-orthopedic3@2x.6c8db84d.png";